import React from 'react'
import { useNavigate } from 'react-router-dom';
import MenuIcon from "@mui/icons-material/Menu";

// import 
// import compnaylog from './First_page';
export default function Header() {
  const navi = useNavigate();
  var list_objs = ["All", "Techologies", "My Post"];
  function eventHandler(e) {
    var slider_name = e.target.innerText;
    console.log({ "innerText:": e.target.innerText });
    slider_name.includes("Tech")
      ? navi("/tech")
      : slider_name.includes("Daily")
      ? navi("/dailyblog")
      : slider_name.includes("My")
      ? navi("/mypost")
      : navi("/");
  }
  return (
    <div className="Header">
      <div className="Icon">
        <h1> Blogify </h1>
      </div>
      <div className="Slider">
        {list_objs.map((e, i) => {
          return (
            <div key={i} onClick={eventHandler} className="same" id={`_${i}`}>
              {e}
            </div>
          );
        })}
      </div>
      <div className="User_icon">
        <div className="user_image"></div>
        <h3 id="h_3">Hi! User</h3>
      </div>
      <MenuIcon id="menu_icon" sx={{ color: "black", fontSize: "22px" }} />
    </div>
  );
}
